import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import SEO from './components/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import HowWeHelp from './components/HowWeHelp';
import Services from './components/Services';
import Methodology from './components/Methodology';
import Differentiators from './components/Differentiators';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import BlogSection from './components/BlogSection';
import BlogPage from './components/BlogPage';
import ArticlePage from './components/ArticlePage';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import Contact from './components/Contact';
import WhatsAppButton from './components/WhatsAppButton';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import AdminSettings from './components/AdminSettings';
import AdminBlog from './components/AdminBlog';
import AdminTestimonials from './components/AdminTestimonials';
import AdminFAQ from './components/AdminFAQ';
import AdminProfile from './components/AdminProfile';
import ProtectedRoute from './components/ProtectedRoute';
import CookieBanner from './components/CookieBanner';
import GlobalTracker from './components/GlobalTracker';
import { getSchemaData, getFAQSchema } from './utils/schema';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Toaster position="bottom-right" richColors />
          <SEO />
          {/* Schema.org dados estruturados */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getSchemaData())
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getFAQSchema())
          }}
        />
        
        <GlobalTracker />
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <About />
              <HowWeHelp />
              <Services />
              <Methodology />
              <Differentiators />
              <Testimonials />
              <FAQ />
              <BlogSection />
              <FinalCTA />
            </>
          } />
          <Route path="/contato" element={<Contact />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/settings" element={
            <ProtectedRoute>
              <AdminSettings />
            </ProtectedRoute>
          } />
          <Route path="/admin/blog" element={
            <ProtectedRoute>
              <AdminBlog />
            </ProtectedRoute>
          } />
          <Route path="/admin/testimonials" element={
            <ProtectedRoute>
              <AdminTestimonials />
            </ProtectedRoute>
          } />
          <Route path="/admin/faq" element={
            <ProtectedRoute>
              <AdminFAQ />
            </ProtectedRoute>
          } />
          <Route path="/admin/profile" element={
            <ProtectedRoute>
              <AdminProfile />
            </ProtectedRoute>
          } />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <CookieBanner />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
